import { z } from "zod";

export const WORKFORCE_TRACKS = {
  TRUCKING: "Commercial trucking",
  HEAVY_EQUIPMENT: "Heavy-equipment operations",
} as const;
export const WORKFORCE_INTEREST_TYPES = {
  WORKER: "Worker",
  EMPLOYER: "Employer",
  TRAINING_PARTNER: "Training partner",
  PROGRAMME_PARTNER: "Programme partner",
} as const;
export const WORKFORCE_COUNTRIES = {
  US: "United States",
  CA: "Canada",
  EITHER: "Either country",
} as const;
export const WORKFORCE_NOTICE_VERSION = "WW-MOBILITY-2026-10-16";

export const WorkforceInterestSchema = z
  .object({
    interestType: z.enum([
      "WORKER",
      "EMPLOYER",
      "TRAINING_PARTNER",
      "PROGRAMME_PARTNER",
    ]),
    contactName: z
      .string()
      .trim()
      .min(2, "Enter a contact name of at least 2 characters.")
      .max(160),
    email: z
      .string()
      .trim()
      .toLowerCase()
      .email("Enter a valid contact email.")
      .max(254),
    organization: z.string().trim().max(200),
    community: z
      .string()
      .trim()
      .min(2, "Enter the community or location.")
      .max(160),
    track: z.enum(["TRUCKING", "HEAVY_EQUIPMENT"]),
    destination: z.enum(["US", "CA", "EITHER"]),
    experience: z.enum(["NEW", "UNDER_TWO", "TWO_PLUS", "NOT_APPLICABLE"]),
    capacity: z.string().trim().max(1000),
    consent: z.literal(true, {
      error: "Confirm permission to record and contact this person.",
    }),
    acknowledgement: z.literal(true, {
      error: "Confirm that the programme notice has been explained.",
    }),
    noticeVersion: z.literal(WORKFORCE_NOTICE_VERSION),
  })
  .strict()
  .superRefine((value, ctx) => {
    if (value.interestType !== "WORKER" && value.organization.length < 2)
      ctx.addIssue({
        code: "custom",
        path: ["organization"],
        message: "Enter the partner organization name.",
      });
    if (
      value.interestType === "WORKER" &&
      value.experience === "NOT_APPLICABLE"
    )
      ctx.addIssue({
        code: "custom",
        path: ["experience"],
        message: "Choose the worker’s experience level.",
      });
  });
export type WorkforceInterest = z.infer<typeof WorkforceInterestSchema>;
export interface WorkforceInterestRecord extends WorkforceInterest {
  id: string;
  status: "INTEREST_RECORDED";
  createdAt: string;
}
export interface WorkforceInterestPage {
  items: WorkforceInterestRecord[];
  hasMore: boolean;
}
